import { isValidEmail, isValidThaiNationalID } from "@/libs/commons";

export default {
  methods: {
    isValidEmail: isValidEmail,
    isValidThaiNationalID: isValidThaiNationalID,
  },
};
